import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import {
	ContactContainer,
	DataContainer,
	StyledSocialContainer,
	ContactImage
} from './styles';
import { useTranslation } from 'react-i18next';
import Animation from '../../../../components/Animation';
import { Typography, Grid, IconButton } from '@material-ui/core';
import LabelTitle from '../../../../components/Titles/LabelTitle';
import Form from './Form';
import SocialNetworks from './SocialNetworks';
import KeyboardArrowUpRoundedIcon from '@material-ui/icons/KeyboardArrowUpRounded';
import { scrollToContactSelector } from '../../selectors';
import { scrollToTop } from '../../actions';
import LegalWarning from './LegalWarning';
import SocialMedia from './SocialMedia';
import ContactImageES from '../../../../assets/images/contact3.png';
import ContactImageEN from '../../../../assets/images/contact3-EN.png';

const Contact = props => {
	const ref = useRef(null);
	const { t, i18n } = useTranslation();
	const isEnglish = i18n.language === 'en';

	useEffect(() => {
		if (props.scrollToContact) {
			ref.current.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
	}, [props.scrollToContact]);

	return (
		<ContactContainer ref={ref}>
			<DataContainer>
				<Animation animateIn="fadeInLeft">
					<LabelTitle content={t('general.contact.label')} />
					<Typography variant="h2" color="textPrimary">
						{t('general.contact.title')}
					</Typography>
				</Animation>
				<Grid container className="contact__container">
					<Grid item xs={12} sm={5} className="contact__form">
						<Form />
					</Grid>
					<Grid item xs={12} sm={7} className="contact__social">
						<StyledSocialContainer>
							<SocialNetworks />
						</StyledSocialContainer>

						<SocialMedia />

						<ContactImage background={isEnglish ? ContactImageEN : ContactImageES} />
					</Grid>
				</Grid>
				<IconButton
					aria-label="arrow-top"
					className="button__arrow-top"
					onClick={props.scrollToTop}
				>
					<KeyboardArrowUpRoundedIcon />
				</IconButton>
				<ContactImage
					background={isEnglish ? ContactImageEN : ContactImageES}
					mobile
				/>
			</DataContainer>
			<LegalWarning />
		</ContactContainer>
	);
};

const mapStateToProps = state => {
	return {
		scrollToContact: scrollToContactSelector(state)
	};
};

const mapDispatchToProps = dispatch => {
	return {
		scrollToTop: payload => scrollToTop(dispatch, payload)
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Contact);
